module.exports = __webpack_public_path__ + "static/media/32-9.82ab9aeb.mp3";